export enum SortBy
{
    Name = "Name",
    Email = "Email",
    Role = 'Role',
    Phone= "",
    City = "City",
    Office = 'Office',
    Floor= "Floor",
    Gate = "Gate",
    Status = 'Status',
    CheckIn = 'CheckIn' ,
    CheckOut = 'CheckOut' ,
    Mode='Mode',
    ChangeAttribute = 'ChangeAttribute',
    BadgeStatus='BadgeStatus',
    EmployeeType='EmmployeeType',
    Agency = 'Agency',     
    Designation = 'Designation'     
}